module.exports = __webpack_public_path__ + "images/6721000f2c2e810bcd0c776b5a328454.svg";